// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__d+u0+","buttonWrapper":"styles_buttonWrapper__--QAl"};